import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {loadClubs, loadPrepaidBagProducts} from "./asyncActions";
import {Club} from "../../../api/ClubService";
import {PrepaidBagProduct} from "../../../api/PrepaidBagProductService";

interface SelectedClubState {
    club?: Club
    prepaidBagProducts?: PrepaidBagProduct[]
}

interface State {
    allClubs: Club[]
    selected: SelectedClubState
}

const initialState: State = {
    allClubs: [],
    selected: {

    }
};

export interface LoadClubsActionPayload {
    clubs?: Club[]
}

export interface LoadPrepaidBagProductsActionPayload {
    products?: PrepaidBagProduct[]
}

let clubSelectionSlice = createSlice(
    {
        name: "Clubs",
        initialState: initialState,
        reducers: {
            handleClubChange: (state, action: PayloadAction<string | undefined>) => {
                let clubId = action.payload

                if (!clubId) {
                    return state;
                }

                const selectedClub = state.allClubs
                    .find((item) => item.id === clubId);
                if (!selectedClub) {
                    return;
                }

                state.selected.club = selectedClub
                state.selected.prepaidBagProducts = undefined
            },
        },
        extraReducers: (builder) => {
            builder.addCase(
                loadClubs.fulfilled,
                (state, action: PayloadAction<LoadClubsActionPayload>) => {
                    if (action.payload.clubs) {
                        state.allClubs = action.payload.clubs
                    }
                }
            )
            builder.addCase(
                loadPrepaidBagProducts.fulfilled,
                (state, action: PayloadAction<LoadPrepaidBagProductsActionPayload>) => {
                    state.selected.prepaidBagProducts = action.payload.products
                }
            )
        }
    }
);

export const { handleClubChange } = clubSelectionSlice.actions;

export default clubSelectionSlice.reducer;